import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=41960baa&scoped=true&"
import script from "./Usuario.vue?vue&type=script&lang=js&"
export * from "./Usuario.vue?vue&type=script&lang=js&"
import style0 from "./Usuario.vue?vue&type=style&index=0&id=41960baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41960baa",
  null
  
)

export default component.exports